<template>
  <status-modal-in-progress>
    <template #upper-title>
      {{ $t('WithdrawToCard | successUpperTitle') }}
    </template>

    <template #title>- {{ coinAmount }} {{ coin?.title }}</template>

    <template #description>
      {{ formatFiatAmount(fiatAmount) }}
    </template>

    <template #additional-content>
      <div class="card-number-block">
        {{ formattedCardNumber || formattedPhoneNumber }}
      </div>
    </template>

    <template #actions>
      <base-button
        type="cta"
        size="lg"
        data-cy="withdraw-to-card-success-repeat"
        @onClick="$emit('close')"
      >
        {{ $t('WithdrawToCard | actionClose') }}
      </base-button>
      <base-button
        type="shade"
        size="lg"
        :href="ROUTES.WALLET.HISTORY"
        data-cy="withdraw-to-card-success-go-to-history"
      >
        {{ $t('WithdrawToCard | actionGoToHistory') }}
      </base-button>
    </template>
  </status-modal-in-progress>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import Utils from '@emcd-shared/utils/formatters'
import BaseButton from '@/shared/ui/BaseButton/BaseButton.vue'
import { StatusModalInProgress } from '@/shared/ui/StatusModalInProgress'
import { formatCardNumber } from '@/shared/lib/formatCardNumber'
import { ROUTES } from '@/shared/constants/routes'

const { locale } = useI18n()

const props = defineProps({
  coinAmount: {
    type: String,
  },
  fiatAmount: {
    type: String,
  },
  coin: {
    type: Object,
  },
  fiat: {
    type: Object,
  },
  cardNumber: {
    type: String,
  },
  phoneNumber: {
    type: String,
  },
})

defineEmits(['close'])

const formattedCardNumber = computed(() => {
  if (props.cardNumber?.length !== 16) return props.cardNumber
  return formatCardNumber(props.cardNumber)
})

const formattedPhoneNumber = computed(() => {
  if (!props.phoneNumber?.length) return ''
  return `+${props.phoneNumber}`
})

function formatFiatAmount(value) {
  return Utils.formatCurrency(
    value,
    props.fiat.value,
    2,
    false,
    'floor',
    {},
    locale.value
  )
}
</script>

<style scoped lang="scss">
.card-number-block {
  padding: 6px;
  border-radius: 6px;
  border: 1px solid var(--bg-35);
  background: var(--bg-3);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
</style>
